/* Homepage inline quantities; mutations are serialized and never navigate. */
(() => {
  const selector = '.mn-best-products__cart-form,.mn-combos__cart-form';
  const root = window.Shopify?.routes?.root || '/';
  let cart = null, queue = Promise.resolve(), busy = false;
  const forms = () => [...document.querySelectorAll(selector)];
  const variant = form => String(form.elements.id.value);
  const line = (data, id) => data.items.find(item => String(item.variant_id) === id && !item.selling_plan_allocation && !Object.keys(item.properties || {}).length);
  async function request(path, body) {
    const response = await fetch(root + path, {
      method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      ...(body ? { body: JSON.stringify(body) } : {})
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Unable to update cart. Please try again.');
    return data;
  }
  function render(data) {
    cart = data;
    forms().forEach(form => {
      const qty = line(data, variant(form))?.quantity || 0;
      const add = form.querySelector('[name="add"]');
      const stepper = form.querySelector('.mn-inline-quantity');
      if (!stepper) return;
      add.hidden = qty > 0;
      stepper.hidden = !qty;
      stepper.querySelector('output').textContent = qty;
    });
    document.querySelectorAll('.cart_count_items,.open-cart-drawer a > span:last-child').forEach(node => { node.textContent = data.item_count; });
  }
  function init() {
    forms().forEach(form => {
      if (form.querySelector('.mn-inline-quantity')) return;
      form.querySelector('[name="add"]').dataset.soldOut = String(form.querySelector('[name="add"]').disabled);
      const control = document.createElement('div');
      control.className = 'mn-inline-quantity'; control.hidden = true;
      control.setAttribute('role', 'group'); control.setAttribute('aria-label', 'Quantity in cart');
      control.innerHTML = '<button type="button" data-mn-delta="-1" aria-label="Remove one from cart">−</button><output aria-label="Quantity in cart">0</output><button type="button" data-mn-delta="1" aria-label="Add one to cart">+</button>';
      const status = document.createElement('p');
      status.className = 'mn-inline-status'; status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite');
      form.append(control, status);
    });
    if (cart) render(cart);
  }
  function lock(value) {
    busy = value;
    forms().forEach(form => {
      form.setAttribute('aria-busy', String(value));
      form.querySelectorAll('button').forEach(button => {
        button.disabled = value || button.dataset.soldOut === 'true';
      });
      const select = form.querySelector('select'); if (select) select.disabled = value;
    });
  }
  function mutate(form, delta) {
    if (busy) return;
    const id = variant(form), status = form.querySelector('.mn-inline-status');
    lock(true); status.textContent = '';
    queue = queue.then(async () => {
      const before = await request('cart.js');
      const current = line(before, id);
      if (current) {
        await request('cart/change.js', { id: current.key, quantity: Math.max(0, current.quantity + delta) });
      } else if (delta > 0) {
        await request('cart/add.js', { items: [{ id, quantity: 1 }] });
      }
      const after = await request('cart.js');
      render(after);
      status.textContent = '';
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }).catch(async error => {
      status.textContent = error.message;
      try { render(await request('cart.js')); } catch (_) {}
    }).finally(() => lock(false));
  }
  document.addEventListener('submit', event => {
    const form = event.target.closest(selector); if (!form) return;
    event.preventDefault(); event.stopImmediatePropagation(); init(); mutate(form, 1);
  }, true);
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-mn-delta]');
    const form = button?.closest(selector); if (!form) return;
    event.preventDefault(); event.stopImmediatePropagation(); mutate(form, Number(button.dataset.mnDelta));
  }, true);
  document.addEventListener('change', event => {
    if (event.target.matches('select') && event.target.closest(selector)) { if (cart) render(cart); refresh(); }
  });
  async function refresh() {
    if (busy) return;
    try { render(await request('cart.js')); } catch (_) {}
  }
  init(); refresh();
  document.addEventListener('shopify:section:load', () => { init(); refresh(); });
  window.addEventListener('pageshow', refresh);
  document.addEventListener('hidden.bs.offcanvas', refresh);
})();
